// Global function to show publish success modal
let showPublishSuccessFn: ((options?: { title?: string; message?: string; onGoHome?: () => void }) => void) | null = null;

export const setPublishSuccessHandler = (handler: (options?: { title?: string; message?: string; onGoHome?: () => void }) => void) => {
  showPublishSuccessFn = handler;
};

export const showPublishSuccess = (options?: { title?: string; message?: string; onGoHome?: () => void }) => {
  if (showPublishSuccessFn) {
    showPublishSuccessFn(options);
  }
};

